// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__L1hLN","modal":"Modal_modal__A-T+1","slide-down":"Modal_slide-down__7k3V3"};